var styles = {
  "PlainAction": "Online-Store-UI-PlainAction_n440m",
  "hyperlink": "Online-Store-UI-PlainAction--hyperlink_1omts",
  "subtitle": "Online-Store-UI-PlainAction--subtitle_3bs0v",
  "looseLineHeight": "Online-Store-UI-PlainAction--looseLineHeight_19ksn",
  "extraLooseLineHeight": "Online-Store-UI-PlainAction--extraLooseLineHeight_78y1e",
  "fontSizeBodyMd": "Online-Store-UI-PlainAction--fontSizeBodyMd_7oh5v",
  "small": "Online-Store-UI-PlainAction--small_1eocp",
  "fontSizeBodyLg": "Online-Store-UI-PlainAction--fontSizeBodyLg_zjwzi",
  "fontSizeBodyXl": "Online-Store-UI-PlainAction--fontSizeBodyXl_anw6c",
  "noPadding": "Online-Store-UI-PlainAction--noPadding_1wc2h",
  "hasContent": "Online-Store-UI-PlainAction--hasContent_pv3a7",
  "slim": "Online-Store-UI-PlainAction--slim_1psxk",
  "iconOnly": "Online-Store-UI-PlainAction--iconOnly_e6aqy",
  "disclosure": "Online-Store-UI-PlainAction--disclosure_1sbdx",
  "extraPadding": "Online-Store-UI-PlainAction--extraPadding_cmagy",
  "paddingLoose": "Online-Store-UI-PlainAction--paddingLoose_1fikm",
  "backgroundSubdued": "Online-Store-UI-PlainAction--backgroundSubdued_nxbi2",
  "withSurfaceSubduedBackground": "Online-Store-UI-PlainAction--withSurfaceSubduedBackground_xznuv",
  "backgroundDark": "Online-Store-UI-PlainAction--backgroundDark_1a4xp",
  "backgroundGrey": "Online-Store-UI-PlainAction--backgroundGrey_18256",
  "interactive": "Online-Store-UI-PlainAction--interactive_1ivtu",
  "disabled": "Online-Store-UI-PlainAction--disabled_1589v",
  "pressed": "Online-Store-UI-PlainAction--pressed_idmnq",
  "destructive": "Online-Store-UI-PlainAction--destructive_1bqbv",
  "darkInverse": "Online-Store-UI-PlainAction--darkInverse_165nr",
  "dark": "Online-Store-UI-PlainAction--dark_1pt4g",
  "Subtitle": "Online-Store-UI-PlainAction__Subtitle_3bs0u",
  "unstyled": "Online-Store-UI-PlainAction--unstyled_14zjv",
  "alignLeft": "Online-Store-UI-PlainAction--alignLeft_1syii",
  "fullWidth": "Online-Store-UI-PlainAction--fullWidth_o8lyl",
  "loading": "Online-Store-UI-PlainAction--loading_19047",
  "outline": "Online-Store-UI-PlainAction--outline_1s0du",
  "vertical": "Online-Store-UI-PlainAction--vertical_6sjnz",
  "Interior": "Online-Store-UI-PlainAction__Interior_1hhsk",
  "Prefix": "Online-Store-UI-PlainAction__Prefix_ur12x",
  "WrappedContent": "Online-Store-UI-PlainAction__WrappedContent_j452a",
  "Disclosure": "Online-Store-UI-PlainAction__Disclosure_1sbdx",
  "SubtitleWrapperContent": "Online-Store-UI-PlainAction__SubtitleWrapperContent_ado0f",
  "ExternalIcon": "Online-Store-UI-PlainAction__ExternalIcon_1uns6",
  "PrefixItem": "Online-Store-UI-PlainAction__PrefixItem_76cba",
  "truncate": "Online-Store-UI-PlainAction--truncate_1n0c5",
  "multilineTruncate": "Online-Store-UI-PlainAction--multilineTruncate_u3egb",
  "Content": "Online-Store-UI-PlainAction__Content_q8wcw",
  "removeUnderline": "Online-Store-UI-PlainAction--removeUnderline_15nts",
  "IconWrapper": "Online-Store-UI-PlainAction__IconWrapper_f2ynb",
  "LoadingIndicator": "Online-Store-UI-PlainAction__LoadingIndicator_1wi3c",
  "toneMagic": "Online-Store-UI-PlainAction--toneMagic_chmrx"
};

export { styles as default };
